/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const SET_POLICY_MEASURES_FORM_DATA = "SET_POLICY_MEASURES_FORM_DATA";
export const GET_ALL_MEASURES = "GET_ALL_MEASURES";
export const ERROR_MEASURES = "getting measures";
export const ERROR_MEASURE_GROUP = "getting measures group";
export const GET_ALL_MEASURE_GROUP = "GET_ALL_MEASURE_GROUP";
export const SET_MEASURES_FORM_DATA = "SET_MEASURES_FORM_DATA";
export const SET_POLICY_MEASURES_FORM_ERROR = "SET_POLICY_MEASURES_FORM_ERROR";
export const UPDATE_POLICY_MEASURES_FORM_ERROR = "UPDATE_POLICY_MEASURES_FORM_ERROR";